<template>
  <MensagemErro v-if="erro" :titulo="titulo" :classe="nomeImposto" />
  <LoadingResultado borderTop v-else-if="ativarLoading" :titulo="titulo" :classe="nomeImposto" />
  <MensagemIpi v-else-if="dadosForm.regra == 0" :titulo="titulo" :classe="nomeImposto" />
  <MultiplosSemResultado v-else-if="!exibeImposto" :titulo="titulo" :classe="nomeImposto" />
  <div v-else-if="imposto">
    <h2 class="nome-impressao">CIDE COMBUSTÍVEL</h2>
    <QuadroAlerta
      v-if="!!imposto.dados.length"
      :classe="nomeImposto"
      :dadosForm="dadosForm"
      @exibeAlerta="alerta => (exibeAlerta = alerta)"
    />
    <QuadroPrincipal
      :borderTop="!imposto.dados.length || !exibeAlerta"
      :key="getRenderKey"
      :titulo="imposto.nome"
      :classe="imposto.classe"
    >
      <RegistrosCideCombustivel
        :imposto="imposto"
        :edita="edita"
        :registroSelecionado="registroSelecionado"
        :seleciona="seleciona"
        :selecionouCideCombustivel="selecionouCideCombustivel"
      />
    </QuadroPrincipal>
  </div>
</template>

<script>
import LoadingResultado from "@/components/LoadingResultado/LoadingResultado.vue";
import MensagemIpi from "@/components/MensagemIpi/MensagemIpi.vue";
import MensagemErro from "@/components/MensagemErro/MensagemErro.vue";
import MultiplosSemResultado from "@/components/ImpostoSemResultado/MultiplosSemResultado.vue";
import QuadroAlerta from "@/components/QuadroAlerta/QuadroAlerta.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import RegistrosCideCombustivel from "@/components/RegistrosCideCombustivel/RegistrosCideCombustivel.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "CideCombustivel",

  props: {
    id: String | Number,
    buscarImposto: Function,
    tributoAtivo: String,
    limparImpostos: Boolean,
    exibeImposto: Boolean,
    dadosForm: Array | Object
  },

  components: {
    LoadingResultado,
    MensagemIpi,
    MensagemErro,
    MultiplosSemResultado,
    QuadroPrincipal,
    RegistrosCideCombustivel,
    QuadroAlerta
  },

  data() {
    return {
      exibeAlerta: false,
      titulo: "CIDE COMBUSTÍVEL",
      ativarLoading: false,
      nomeImposto: "cide_combustivel",
      imposto: null,
      registroSelecionado: {},
      selecionouCideCombustivel: false,
      erro: false
    };
  },

  created() {
    this.setSelecao({
      selecao: { selecionouCideCombustivel: this.selecionouCideCombustivel },
      id: this.id
    });
  },

  updated() {
    if (this.selecionouCideCombustivel) {
      this.setLog(this.impressaoLog);
    }
  },

  watch: {
    async tributoAtivo(newValue) {
      this.erro = false;
      //olha se o tributo esta ativo, se nao há dado que ja foi chamado e se existe IPI selecionado.
      if (
        newValue == this.nomeImposto &&
        !this.imposto &&
        this.dadosForm.regra != 0 &&
        this.exibeImposto
      ) {
        this.ativarLoading = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            [this.imposto] = await this.buscarImposto({
              imposto: this.nomeImposto,
              idCenario: this.id
            });
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoading = false;
            }
          }
        }
        this.ativarLoading = false;
      }
    },

    limparImpostos(newValue) {
      if (newValue) {
        this.imposto = null;
        this.edita();
      }
    },

    ativarLoading() {
      this.$emit("loading", this.ativarLoading);
    },

    selecionouCideCombustivel() {
      this.setSelecao({
        selecao: { selecionouCideCombustivel: this.selecionouCideCombustivel },
        id: this.id
      });
    }
  },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"]),

    impressaoLog() {
      let log = {
        logCideCombustivel: {
          imposto: this.registroSelecionado
        }
      };
      return log;
    }
  },

  methods: {
    ...mapActions("tributosSelecionados", ["setSelecao"]),
    ...mapActions("logResultados", ["setLog"]),

    seleciona(imposto) {
      this.registroSelecionado = imposto;
      this.selecionouCideCombustivel = true;
    },

    edita() {
      this.registroSelecionado = {};
      this.selecionouCideCombustivel = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
